import { render, staticRenderFns } from "./AddonCard.vue?vue&type=template&id=feccf80a&scoped=true&lang=pug"
import script from "./AddonCard.vue?vue&type=script&lang=js"
export * from "./AddonCard.vue?vue&type=script&lang=js"
import style0 from "./AddonCard.vue?vue&type=style&index=0&id=feccf80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feccf80a",
  null
  
)

export default component.exports